<template>
  <header>
    <div class="container">
      <div class="logo">闯货</div>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
header{
  height: 50px;
  background: #fff;
  .logo {
    font-size: 20px;
    line-height: 50px;
    color: #ff4d2f;
    font-weight: bold;
    margin: 0 10px;
  }
}
@media screen and (min-width: 768px) {
  header {
    height: 70px;
    .logo {
      font-size: 24px;
      line-height: 70px;
    }
  }
}
</style>
